import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Ana Sayfa', href: '/' },
  { label: 'Hakkımızda', href: '/hakkimizda' },
  { label: 'Hizmetler', href: '/hizmetler' },
  { label: 'Ürünler', href: '/urunler' },
  { label: 'Referanslar', href: '/referanslar' },
  { label: 'Blog', href: '/blog' },
  { label: 'SSS', href: '/sss' },
];

interface NavbarProps {
  transparent?: boolean;
}

export default function Navbar({ transparent = false }: NavbarProps) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isLight = !transparent || scrolled;

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isLight ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center cursor-pointer">
          <img
            src="/images/logo.webp"
            alt="İzmir Lightbox Logo"
            width="148"
            height="48"
            className="h-10 md:h-12 w-auto object-contain"
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-5">
          {navLinks.map((link) => (
            <Link
              key={link.label}
              to={link.href}
              className={`text-sm font-medium transition-colors hover:text-red-600 whitespace-nowrap cursor-pointer ${
                location.pathname === link.href
                  ? 'text-red-600'
                  : isLight
                  ? 'text-gray-700'
                  : 'text-white'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/iletisim"
            className="bg-red-600 text-white text-sm font-semibold px-5 py-2 rounded-md hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            Teklif Al
          </Link>
        </nav>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden flex items-center justify-center w-10 h-10 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label={menuOpen ? 'Menüyü kapat' : 'Menüyü aç'}
          aria-expanded={menuOpen}
        >
          <i className={`text-xl ${isLight ? 'text-gray-900' : 'text-white'} ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-4 py-4 flex flex-col gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.label}
              to={link.href}
              className={`text-sm font-medium py-2.5 px-2 rounded-lg hover:text-red-600 hover:bg-red-50 cursor-pointer transition-colors ${
                location.pathname === link.href ? 'text-red-600 bg-red-50' : 'text-gray-700'
              }`}
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/iletisim"
            className="bg-red-600 text-white text-sm font-semibold px-5 py-2.5 rounded-md text-center hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer mt-2"
            onClick={() => setMenuOpen(false)}
          >
            Teklif Al
          </Link>
        </div>
      )}
    </header>
  );
}
